module.exports = __webpack_public_path__ + "img/fendanyun_03.3044fd4e.jpg";